module.exports = __webpack_public_path__ + "img/v-loop.091f26ac.svg";